var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from 'classnames';
import { Icons } from 'src/ui/components/Icons/Icons';
import { E_ICONS } from 'src/ui/components/Icons/constants';
import { COLORS } from 'src/shared/styles/colors';
import styles from './CheckList.module.scss';
import { findStringNoCaseSensitive } from 'src/shared/helpers/stringHelpers';
import { getPropsByKeyPath } from 'src/shared/helpers/objHelpers';
import { IDENTIFIER_CHECKLIST, IDENTIFIER_CHECKLIST_ITEM } from 'src/ui/components/Input/CheckList/constants';
/**
 *
 * @param props
 * @constructor
 *
 * Take care of handling mandatory options outside this component, because Checklist doesn't return them when onChange is triggered
 */
export var CheckList = function (props) {
    var i18n = props.i18n, options = props.options, currentOption = props.currentOption, className = props.className, onChange = props.onChange;
    var handleCheckChange = function (e, option) {
        e.stopPropagation();
        var optionAlreadyChecked = currentOption.indexOf(option) !== -1;
        var newOptionsChecked = optionAlreadyChecked
            ? currentOption.filter(function (opt) { return opt !== option; })
            : __spreadArray(__spreadArray([], currentOption, true), [option], false);
        if (onChange) {
            onChange(newOptionsChecked);
        }
    };
    var checkListClass = classNames(styles.checkListOptionsList, className);
    var mandatoryLabel = getPropsByKeyPath(i18n.modules, 'externalComments.requiredDoc');
    return (_jsx("ul", __assign({ "data-test": IDENTIFIER_CHECKLIST, className: checkListClass }, { children: options.map(function (opt) {
            var _a, _b, _c;
            var isChecked = findStringNoCaseSensitive(currentOption, opt.label) || opt.mandatory;
            var itemClassName = classNames(styles.checkListOptionsItem, (_a = {},
                _a[styles.isActive] = isChecked,
                _a[styles.isMandatory] = opt.mandatory,
                _a));
            var iconWrapperClassName = classNames(styles.checkListCheckWrapper, (_b = {}, _b[styles.isActive] = isChecked, _b));
            var iconClassName = classNames(styles.checkListCheckIcon, (_c = {}, _c[styles.isActive] = isChecked, _c));
            return (_jsxs("li", __assign({ "data-test": IDENTIFIER_CHECKLIST_ITEM, onClick: opt.mandatory ? null : function (e) { return handleCheckChange(e, opt.label); }, className: itemClassName }, { children: [_jsx("div", __assign({ className: iconWrapperClassName }, { children: _jsx(Icons, { icon: E_ICONS.CHECK, className: iconClassName, color: COLORS.WHITE }) })), _jsxs("div", __assign({ className: styles.optionItemInfoWrapper }, { children: [_jsx("p", { children: opt.label }), opt.mandatory && _jsxs("p", __assign({ className: styles.optionItemMandatoryLabel }, { children: ["$", mandatoryLabel] }))] }))] })));
        }) })));
};
